'use es6';

let _ = t => t,
    _t;

import styled from 'styled-components';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
const PhoneSupportWrapper = styled.div.withConfig({
  displayName: "PhoneSupportWrapper",
  componentId: "sc-1jpu6um-0"
})(["width:450px;margin:50px auto;", ""], breakpoint.phone(_t || (_t = _`
    width: 100%;
  `)));
export default PhoneSupportWrapper;